export default [
  {
    path: 'operational-reports',
    children: [
      {
        path: 'dashboard',
        name: 'operational_reports_dashboard',
        component: () =>
          import(
            '../../../views/reports/operational/OperationalReportsDashboard.vue'
          ),
        meta: { permissions: ['administrator', 'report_manage'] },
      },
      {
        path: 'teams/:teamId',
        name: 'operational_reports_team',
        component: () =>
          import(
            '../../../views/reports/operational/OperationalReportsTeamDetail.vue'
          ),
        meta: { permissions: ['administrator', 'report_manage'] },
        props: true,
      },
      {
        path: 'agents/:agentId',
        name: 'operational_reports_agent',
        component: () =>
          import(
            '../../../views/reports/operational/OperationalReportsAgentDetail.vue'
          ),
        meta: { permissions: ['administrator', 'report_manage'] },
        props: true,
      },
    ],
  },
];
